module.exports = __webpack_public_path__ + "static/images/document.1owQijz.svg";